import React, { useCallback } from 'react';
import { noop } from 'lodash';
import PropTypes from 'prop-types';
import { useCheckboxState } from 'hooks';
import { UNCHECKED } from 'modules/campaigns/config';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { ModalFormLayout } from 'modules/taboola-common-frontend-modules/modals/components/ModalFormLayout/ModalFormLayout';
import { useLocalStorage } from 'modules/taboola-common-frontend-modules/storage';

const checkboxTitle = (
    <FormattedMessage id="creative-library.modal.checkboxTitle" defaultMessage="Do not show it again" />
);
const LIBRARY_PAUSE_MODAL_KEY = 'shouldHideCreativeLibraryPauseModal';

export const LibraryPauseModal = ({ onClose }) => {
    const {
        onSelectCheckbox,
        onUnselectCheckbox,
        selected: shouldDisableModal,
        setSelected,
        selectedValues,
    } = useCheckboxState(noop, noop);
    const [, setLocalStorage] = useLocalStorage();
    const checkboxData = [{ title: checkboxTitle, value: shouldDisableModal }];

    const handleSubmit = useCallback(() => {
        if (shouldDisableModal) {
            setLocalStorage(LIBRARY_PAUSE_MODAL_KEY, true);
        }
        onClose(true);
    }, [onClose, shouldDisableModal, setLocalStorage]);

    const handleClose = useCallback(() => {
        setSelected(UNCHECKED);
        onClose();
    }, [onClose, setSelected]);

    return (
        <ModalFormLayout
            onCancel={handleClose}
            onSubmit={handleSubmit}
            submitButtonText={
                <FormattedMessage id="creative-library.modal.button.pause" defaultMessage="Pause Creative" />
            }
            onSelectCheckbox={onSelectCheckbox}
            onUnselectCheckbox={onUnselectCheckbox}
            checkboxSelectedValues={selectedValues}
            checkboxData={checkboxData}
        >
            <FormattedMessage
                id="creative-library.modal.content.pause"
                defaultMessage="Pausing this creative will stop it from serving in all ad groups until reactivated. Historical reporting data will be preserved."
            />
        </ModalFormLayout>
    );
};

LibraryPauseModal.propTypes = {
    onClose: PropTypes.func,
};
